import { FormContext } from '@bnnvara/forms/src/new_components/BaseForm/FormContext';
import { Checkbox } from '@bnnvara/forms/src/new_components/inputs/Checkbox/Checkbox';
import { RadioGroup } from '@bnnvara/forms/src/new_components/inputs/RadioGroup/RadioGroup';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';

import * as S from './styled';

/**
 * The state `shouldTriggerSubmit` is used to wait for the values of the FormContext to be set. This needs to be done
 * because we are listening to the onChange events on the Checkbox and Radio. These functions are called immediately
 * while the value is set with a setValue on the context. That means that is not directly available. By using a
 * useEffect we know for sure the state is updated and we can use the values stored in the context.
 */
export function SettingFormFields({
  editorialNotificationPerEmail,
  editorialNotificationInterval,
}) {
  const { triggerSubmit } = useContext(FormContext);

  function handleChange() {
    setTimeout(() => {
      triggerSubmit();
    }, 100);
  }

  return (
    <>
      <Checkbox
        name="editorialNotificationPerEmail"
        label="Ja, ik wil graag berichten per e-mail ontvangen als er een nieuwe publicatie is van een BNNVARA-titel die ik volg"
        value={editorialNotificationPerEmail}
        onChange={handleChange}
      />

      <S.Radios>
        <RadioGroup
          value={editorialNotificationInterval}
          name="editorialNotificationInterval"
          onChange={handleChange}
          options={[
            {
              value: 'None',
              label: 'Zodra er nieuwe publicaties zijn',
            },
            {
              value: 'Daily',
              label: 'Stuur mij een dagelijkse samenvatting',
            },
          ]}
        />
      </S.Radios>
    </>
  );
}

SettingFormFields.defaultProps = {
  editorialNotificationInterval: 'None',
};

SettingFormFields.propTypes = {
  editorialNotificationPerEmail: PropTypes.bool,
  editorialNotificationInterval: PropTypes.string,
};
